import styled from "styled-components";
import {
  UnderlineLink,
  PrimaryButtonComponent,
  DisplayFlex
} from "../../../../../../CommonComponents/commonStyles";

export const PopContainer = styled.div`
  text-align: center;
`;
export const PopupHeading = styled.div`
  color: #022737;
  font-family: BerkeleyStd-Bold;
  font-size: 24px;
  padding: 30px 0 15px 0;
  line-height: 1.17;
  margin-left: 43px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    display: flex;
    justify-content: center;
  }
`;

export const PopupContentContainer = styled.div`
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
  color: #505050;
  margin-bottom: 30px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 14px;
  }
`;

export const PopupWrap = styled.div`
  position: fixed;
  background: #ffffff;
  width: ${props => props.width};
  height: ${props => props.height};
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10002;

  @media only screen and (min-width: 320px) and (max-width: 767px) {
    width: ${props => props.mwidth};
    height: ${props => props.mheight};
  }
`;

export const PopupWrapAutofill = styled(PopupWrap)`
  width: 565px;
  height: 347px
`

export const PopupContentLine1 = styled.div`
  padding-bottom: 50px;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    margin: 0 20px;
  }
`;

export const PopupContentLine1Align = styled(PopupContentLine1)`
width: ${props => props.width};
padding-bottom: ${props => props.paddingBottom};
`;

export const DisplayFlexCenter = styled(DisplayFlex)`
  justify-content: center;
`;

export const IconWrap = styled.div`
  float: right;
  margin-top: 20px;
  margin-right: 23px;
  cursor: pointer;
`;

export const PrimaryButton = styled(PrimaryButtonComponent)`
  border-radius: 0;
  border: none !important;
  width: 292px !important;
  height: 50px !important;
  margin-bottom: 10px;
  font-size: 18px;
  font-family: HelveticaNeue-CondensedBlack;
  letter-spacing: 1.1px;
  line-height: 1.67;
  border: none;
  @media only screen and (min-width: 320px) and (max-width: 767px) {
    font-size: 18px !important;
    width: 93% !important;
  }
`;

export const Underlinelink = styled(UnderlineLink)`
  letter-spacing: 0px;
  display: block;
  margin-bottom: 30px;
  font-family: HelveticaNeue;
  font-size: 16px;
  line-height: 1.5;
`;

export const PopContainerWrap = styled.div`
  position: fixed;
  left: 0;
  z-index: 10000;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
  top: 0;
`;
